import { Variant } from "./variant.models";

export class Product {
  id: number;
  code?: string;
  barCode?: string;
  description?: string;
  name: string;
  type: string;
  articleTypeId: number;
  measurementUnitId: number;
  secondaryMeasurementUnitId: number;
  deposito: any;
  stock: any;
  stockminimo: number;
  stockmaximo: number;
  taxes: any;
  salePriceWithoutIva: number;
  purchasePriceWithoutIva: number;
  purchasePrice: number;
  salePrice: number;
  totalTax: number;
  batch: string;
  expirationDate: string;
  stockactual: number;
  ivaRateId: number;
  ivaPosition: string;
  currencyId: number;
  listaprecio: any;
  categoryId: number;
  brandId: number;
  sku: string;
  variant: number;
  variants: Variant[];
  public: number;
  isComposite: number;
  images: ProductImages[];
  user: string;
  warehouseId: number;
  quantity: number;
  
  // Campos adicionales
  tag?: string;                    // Campo para etiquetas/tags del producto
  seodescription?: string;         // Descripción SEO para e-commerce
  margenGanancia?: number;         // Campo para cálculo de rentabilidad
}

interface ProductImages {
  //id: number;
  nombre: string;
  tamaño: number;
  url: string;
}